import { Typography } from '../../../../../core/components/molecules/Typography';
import { useUserStore } from '../../../../Auth/stores/authStore';

interface IStudyTimeProgressItem {
  day: string;
  progress: number;
  status: 'onTime' | 'late' | 'early';
}
const StudyTimeProgressItem: React.FC<IStudyTimeProgressItem> = ({
  day,
  status,
  progress,
}) => {
  const { user } = useUserStore();

  const isDarkMode = user?.isDarkMode;

  const getStatusColor = () => {
    switch (status) {
      case 'onTime':
        return 'bg-brand-color-primary-pure';
      case 'late':
        return 'bg-feedback-color-error-pure';
      case 'early':
        return 'bg-feedback-color-success-pure';
      default:
        return 'bg-brand-color-primary-pure';
    }
  };

  return (
    <div className='flex flex-col items-center gap-3'>
      <div 
        className={`
          flex h-[160px] w-[10px] flex-col justify-end overflow-hidden rounded-lg shadow-level-1 
          ${isDarkMode ? 'bg-mono-color-lighter' : 'bg-gradient-to-t from-mono-color-lighter to-[#FCFCFC]'}
        `}
      >
        <div
          className={`w-full ${getStatusColor()} rounded-pill transition-all duration-300`}
          style={{ height: `${progress}%` }}
        />
      </div>
      <Typography size='mini' className='text-mono-color-dark'>
        {day}
      </Typography>
    </div>
  );
};

export default StudyTimeProgressItem;
